import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import { ErrorState, LoadingState } from "../components/ui";

export function AuthCallbackPage() {
  const { completeSignIn } = useAuth();
  const [error, setError] = useState<unknown>();
  useEffect(() => {
    completeSignIn()
      .then((returnTo) => window.location.replace(returnTo))
      .catch(setError);
  }, [completeSignIn]);
  return (
    <main className="p-6">{error ? <ErrorState error={error} onRetry={() => window.location.assign("/login")} /> : <LoadingState label="Completing sign-in" />}</main>
  );
}
